import MainContent from "./components/MainContent"
import Navbar from "./components/Navbar"

const App = () => {
  return (
    <>
      <Navbar />
      <MainContent />
    </>
  )
}

export default App